import React, {Component} from 'react';
import ReactGA from 'react-ga4';
import {Provider} from 'react-redux';
import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { BrowserRouter as Router } from 'react-router';
import throttle from "lodash/throttle";
import CartErrorModal from './components/CartErrorModal';


import Header from './components/Header';
import Routes from './Routes';

import configureStore from './configureStore';
import CoronaHeader from "./components/CoronaHeader";
import {removeLocalStorageState, saveState} from "./localStorage";
import ThemableComponent from "./components/theme/ThemableComponent";
import {getEnvironment} from "./utils/themeUtils";
import {getGAID, useGoogleAnalytics} from "./utils/configUtils";
import { t } from "@lingui/core/macro";

export const store = configureStore();


class App extends Component {
    constructor(props) {
        super(props);
        this.storeUnsubscribe = null;
    }

    componentDidMount() {
        // TODO - temporary change only - revert back once texts and wishes are known
        // const consentGiven = getCookieConsentValue();
         const consentGiven = "true";

         if(consentGiven === "true") {
             if(useGoogleAnalytics()) {
                 // initialize google analytics and set up local storage
                 this.handleAcceptCookie();
             }
             else {
                // only set up local storage
                 this.setUpLocalStorage();
             }
         }

        document.title = getEnvironment("PAGE_TITLE");
    }

    componentWillUnmount() {
        if(this.storeUnsubscribe) {
            this.storeUnsubscribe();
        }
    }


    handleAcceptCookie = () => {
        ReactGA.initialize({
            trackingId: getGAID(),
        });

        this.setUpLocalStorage();
    }

    setUpLocalStorage = () => {
        // onetime save the current state (in case user gave consent mid session)
        saveState(store.getState());

        // subscribe to all future changes with throttling
        this.storeUnsubscribe = store.subscribe(throttle(() => {
            saveState(store.getState());
        }, 2000));
    }

    handleRejectCookie = () => {
        //remove google analytics cookies
        Cookies.remove("_ga");
        Cookies.remove("_gat");
        Cookies.remove("_gid");

        // remove state saved in local storage
        removeLocalStorageState();
    }

    render() {
        return (
            <Provider store={store}>
                <div>
                    <CoronaHeader/>
                    <Header/>

                    {/*main content*/}
                    <div className="main-content">
                        <Router>
                            <Routes />
                        </Router>
                    </div>

                    <ThemableComponent componentName="Footer"/>

                    <CartErrorModal/>

                    {/* TODO uncomment this once texts and behaviour is known */}
                    {/*<CookieConsent*/}
                    {/*    enableDeclineButton*/}
                    {/*    onAccept={this.handleAcceptCookie}*/}
                    {/*    onDecline={this.handleRejectCookie}*/}
                    {/*>*/}
                    {/*    Text about stuff here why cookies are there and what they do and such*/}
                    {/*</CookieConsent>*/}
                </div>
            </Provider>
        );
    }

    _onIdle = (e) => {
        const state = store.getState();
        const agencyLoggedIn = state.agency.isAuthenticated;
        const userLoggedIn = state.authentication.isAuthenticated;

        if (agencyLoggedIn && userLoggedIn) {
            window.location.href = t({id: "/logoutUser"});
        }
    };
}

export default App;
